import { render, staticRenderFns } from "./SelectManyField.vue?vue&type=template&id=cddb3008&"
import script from "./SelectManyField.vue?vue&type=script&lang=js&"
export * from "./SelectManyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SelectManyField.vue"
export default component.exports